/*
 * @Author: zenghao
 * @Date: 2022-05-05 11:14:03
 * @LastEditors: zenghao
 * @LastEditTime: 2022-05-05 11:16:44
 * @Description: 请填写简介
 */

import { useLocal } from "@/pages/dashboard/utils/customHook"

const NoData = () => {
  const { getLocalText } = useLocal('selector_multiple_component')

  return (
    <div className="selector-multiple__dropdown--noData">
      {getLocalText('no_data')}
    </div>
  )
}

export default NoData